import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { Link } from '@tanstack/router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { IS_COUNTRY } from '../../constants/countries'
import useCopy from '../../hooks/useCopyText'
import useMemberInfo from '../../hooks/useMemberInfo'
import { useBoundStore } from '../../store/store'
import classNames from '../../utils/classNames'
import Backdrop from '../common/backdrop'
import LogoutModal from '../common/log-out-modal'
import Icon from '../icon'
import DepositWithdraw from './deposit-withdraw'
import LanguageSelector from './language-selector'
import LoginSignUp from './login-sign-up'
import Tabs from './tabs'
import ThemeSwitch from './theme-switch'

const Sidebar = () => {
  const username = useBoundStore(state => state.user.username)
  const { copyTextToClipboard } = useCopy()
  const { refreshMemberInfo } = useMemberInfo()
  const modal = useModal()
  const logOutModal = useModal(LogoutModal)
  const { t } = useTranslation(['common', 'drawer'])

  useEffect(() => {
    if (!username || !modal.visible) return
    refreshMemberInfo()
  }, [modal.visible])

  return (
    <>
      <Backdrop
        zIndex={150}
        isVisible={modal.visible}
        onClick={() => modal.hide()}
        id="profile-drawer"
      />
      <div
        className={classNames(
          'fixed z-[160] bg-primary transition-all duration-[0.3s] ease-[ease-in-out] w-[330px] h-screen overflow-y-auto overflow-x-hidden pb-[125px] top-0',
          modal.visible
            ? 'pointer-events-auto opacity-100 left-0'
            : 'opacity-0 pointer-events-none -left-full',
        )}>
        <div className="flex justify-between p-[17px]">
          <div>
            <div
              className="flx-str-ctr text-base text-[#888888] uppercase"
              onClick={() => copyTextToClipboard(username, 'Copiado')}>
              {t('drawer:welcome-guest')}
              {username ? ',' : '!'}
              {` ${username}${username && '!'}`}
              {username && (
                <Icon
                  id="copy"
                  width={24}
                  height={24}
                  style={{ marginLeft: 2 }}
                />
              )}
            </div>
          </div>
        </div>
        {!username ? (
          <LoginSignUp closeProfileDrawer={() => modal.hide()} />
        ) : (
          <DepositWithdraw closeProfileDrawer={() => modal.hide()} />
        )}
        <Tabs
          closeProfileDrawer={() => modal.hide()}
          showProfileDrawer={() => modal.show()}
        />
        {username && (
          <button
            className="border-b-[#f5f6f9] dark:border-b-[#1f223c] border-0 border-b border-solid flx-btw-ctr text-highlight uppercase text-base w-full pl-[30px] pr-[15px] py-2.5 [&>svg]:fill-highlight"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              modal.hide()
              logOutModal.show()
            }}>
            {t('logout', { ns: 'drawer' })}
          </button>
        )}
        <Link
          className="tabs text-highlight uppercase text-base w-full inline-flex items-center gap-1 pl-[30px] pr-[15px] py-2.5"
          to="/sponsors"
          onClick={() => {
            modal.hide()
          }}>
          {t('sponsors', { ns: 'drawer' })}
        </Link>
        <ThemeSwitch />

        {IS_COUNTRY.MX && <LanguageSelector />}
      </div>
    </>
  )
}

export default NiceModal.create(Sidebar)
